module.exports = __webpack_public_path__ + "img/space-introduce-6.ea2c5623.svg";